import React from 'react';
import { Header } from './../Header';
import { AgroHeaderContext } from '../../contexts/AgroHeaderContext';
import PropTypes from 'prop-types';
import withCssProps from '../../hocs/withCssProps';
import { getLanguage } from '../AgroHeader/getLanguage';
var AgroHeader = withCssProps(function (_ref) {
  var _ref$baseUrl = _ref.baseUrl,
    baseUrl = _ref$baseUrl === void 0 ? 'https://www.agrofy.com.ar' : _ref$baseUrl,
    loginUrlRedirect = _ref.loginUrlRedirect,
    language = _ref.language,
    tagManager = _ref.tagManager,
    apiGateway = _ref.apiGateway,
    _suggestionCallback = _ref.suggestionCallback,
    onSearchSubmit = _ref.onSearchSubmit,
    _ref$user = _ref.user,
    user = _ref$user === void 0 ? null : _ref$user,
    notifications = _ref.notifications,
    _ref$loadingUser = _ref.loadingUser,
    loadingUser = _ref$loadingUser === void 0 ? false : _ref$loadingUser,
    _ref$loadingNotificat = _ref.loadingNotifications,
    loadingNotifications = _ref$loadingNotificat === void 0 ? false : _ref$loadingNotificat,
    onClick = _ref.onClick,
    urlServices = _ref.urlServices;
  var context = {
    baseUrl: baseUrl,
    loginUrlRedirect: loginUrlRedirect,
    language: language,
    tagManager: tagManager,
    apiGateway: apiGateway,
    onSearchSubmit: onSearchSubmit,
    user: user,
    loadingUser: loadingUser,
    loadingNotifications: loadingNotifications,
    onClick: onClick,
    notifications: notifications,
    urlServices: urlServices,
    translations: getLanguage(language),
    suggestionCallback: function suggestionCallback(text) {
      return _suggestionCallback(text);
    }
  };
  return /*#__PURE__*/React.createElement(AgroHeaderContext.Provider, {
    value: context
  }, /*#__PURE__*/React.createElement(Header, null));
});
AgroHeader.propTypes = {
  baseUrl: PropTypes.string,
  tagManager: PropTypes.func,
  apiGateway: PropTypes.string,
  suggestionCallback: PropTypes.func,
  searchSubmit: PropTypes.func,
  user: PropTypes.object,
  notifications: PropTypes.object,
  loadingUser: PropTypes.bool,
  loadingNotifications: PropTypes.bool,
  onClick: PropTypes.func,
  language: PropTypes.string.isRequired,
  urlServices: PropTypes.string
};
AgroHeader.displayName = 'AgroHeader';
export { AgroHeader };